import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

export default new Router({
	routes:[
		{
			path: '/',
			name: 'index',
			component: () => import('@/views/index')
		},
		{
			path: '/portfolio',
			name: 'portfolio',
			component: () => import('@/views/portfolio')
		},
		{
			path: '/team',
			name: 'team',
			component: () => import('@/views/team')
		},
		{
			path: '/contact',
			name: 'contact',
			component: () => import('@/views/contact')
		},
		{
			path: '/mobi',
			name: 'index_mobi',
			component: () => import('@/views/index_mobi')
		},
		{
			path: '/portfolio_mobi',
			name: 'portfolio_mobi',
			component: () => import('@/views/portfolio_mobi')
		},
		{
			path: '/team_mobi',
			name: 'team_mobi',
			component: () => import('@/views/team_mobi')
		},
		{
			path: '/contact_mobi',
			name: 'contact_mobi',
			component: () => import('@/views/contact_mobi')
		},
		
		
	]
})